var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgVector = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 6,
    viewBox: "0 0 10 6",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.38953 5.36048L0.174419 1.01819C0.116279 0.958298 0.0726744 0.893413 0.0436046 0.823537C0.0145349 0.753661 0 0.678794 0 0.598936C0 0.43922 0.0532946 0.299468 0.159884 0.179681C0.266473 0.0598936 0.406977 0 0.581395 0H9.4186C9.59302 0 9.73353 0.0598936 9.84012 0.179681C9.94671 0.299468 10 0.43922 10 0.598936C10 0.638865 9.94186 0.778617 9.82558 1.01819L5.61047 5.36048C5.51357 5.4603 5.41667 5.53018 5.31977 5.57011C5.22287 5.61004 5.11628 5.63 5 5.63C4.88372 5.63 4.77713 5.61004 4.68023 5.57011C4.58333 5.53018 4.48643 5.4603 4.38953 5.36048Z",
    fill: "#C8131B"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgVector, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/vector.69a3d81c.svg";
export { ForwardRef as ReactComponent };